import React from 'react';
import TilesGroup, { Props as TilesGroupProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content/tiles-group';
import { LOOM_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';

export interface Props {
  children?: React.ReactNode;
  data: TilesGroupProps;
}

const TilesGroupTastic: React.FC<Props> = ({ data }) => {
  return <TilesGroup {...data} backgroundClassName={LOOM_CONTENT_LOOK.tilesGroupBgClassName} />;
};

export default TilesGroupTastic;
